import { render, staticRenderFns } from "./DetalheDevolucaoTotal.vue?vue&type=template&id=96d5d96c&scoped=true&"
import script from "./DetalheDevolucaoTotal.vue?vue&type=script&lang=js&"
export * from "./DetalheDevolucaoTotal.vue?vue&type=script&lang=js&"
import style0 from "./DetalheDevolucaoTotal.vue?vue&type=style&index=0&id=96d5d96c&scoped=true&lang=css&"
import style1 from "./DetalheDevolucaoTotal.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d5d96c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
